<div *ngIf="display" class="t-popup popup-clinic-autotext popup-centered">
  <div class="t-popup-frame">
    <div class="t-popup-body">

      <button class="t-btn-popup-close" aria-label="close popup" (click)="doClose()"></button>

      <h2>AutoTexts for "{{ clinicTemplateTitle }}"</h2>

      <div class="content-row">
        <div class="editor-panel">
          <h3>{{ editingId ? 'Edit Auto textes' : 'New list' }}</h3>
<br/>
          <label class="field">
            <span> Category Name</span>
            <input type="text" [(ngModel)]="title" placeholder="e.g. Findings" />
          </label>

          <div class="snippets">
            <span class="field-label">Auto Text </span>
            <div class="snippet-row" *ngFor="let s of snippets; let i = index">
              <textarea class="snippet-content" [(ngModel)]="s.Content" placeholder="Auto text" rows="2"></textarea>
              <button type="button" class="orange-btn -sm" (click)="removeSnippetRow(i)">Remove</button>
            </div>
            <button type="button" class="blue-btn -sm" (click)="addSnippetRow()">Add Auto Text</button>
          </div>

          <div class="actions">
            <button type="button" class="blue-btn" [disabled]="!title || loading" (click)="save()">
              {{ editingId ? 'Update' : 'Create' }}
            </button>
            <button type="button" class="orange-btn" *ngIf="editingId" (click)="resetForm()" [disabled]="loading">Cancel</button>
          </div>
        </div>

        <div class="list-panel">
          <h3>Auto texts for template</h3>
          <div class="list-list" *ngIf="scopedLists.length">
            <div class="list-card" *ngFor="let l of scopedLists" [class.editing]="l.AutoTextListID === editingId">
              <div class="list-card-title">{{ l.Title }}</div>
              <div class="list-card-snippets">{{ l.snippets?.length || 0 }} Auto Texts</div>
              <div class="list-card-actions">
                <button type="button" class="blue-btn" (click)="edit(l)" [disabled]="loading">Edit</button>
                <button type="button" class="orange-btn" (click)="confirmDelete(l)" [disabled]="loading">Delete</button>
              </div>
            </div>
          </div>
          <div *ngIf="!scopedLists.length" class="empty">No AutoText lists for this template yet</div>
        </div>
      </div>

    </div>
  </div>
</div>

<div *ngIf="showDeleteConfirm" class="t-popup popup-patientDetails popup-centered">
  <div class="t-popup-frame">
    <div class="t-popup-body">

      <button class="t-btn-popup-close" aria-label="close popup" (click)="cancelDelete()"></button>

      <h2 style="color: #D7A95B; text-align: center;">
        Delete list "{{ listToDelete?.Title }}"?
        <br>
        This cannot be undone. If this list is shared with other templates it will be removed for them too.
      </h2>
      <div style="display: flex; justify-content: center;">
        <button class="blue-btn" [disabled]="loading" (click)="doDelete()">Yes</button>
        <button class="orange-btn" style="margin-left: 2em" [disabled]="loading" (click)="cancelDelete()">No</button>
      </div>

    </div>
  </div>
</div>
